import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const ContactsPersonsPage = lazy(() => import('@/pages/contacts/ContactsPersonsPage'));
const ContactsCompaniesPage = lazy(() => import('@/pages/contacts/ContactsCompaniesPage'));
const ContactDetailLayout = lazy(() => import('@/pages/contacts/ContactDetailLayout'));
const ContactDetailsLayout = lazy(() => import('@/pages/contacts/ContactDetailsLayout'));
const ContactDetailsInformationTab = lazy(() => import('@/pages/contacts/ContactDetailsInformationTab'));
const ContactDetailsNotesTab = lazy(() => import('@/pages/contacts/ContactDetailsNotesTab'));
const ContactDetailsSettingsTab = lazy(() => import('@/pages/contacts/ContactDetailsSettingsTab'));
const ContactBankAccountsPage = lazy(() => import('@/pages/contacts/ContactBankAccountsPage'));
const ContactEstatesPage = lazy(() => import('@/pages/contacts/ContactEstatesPage'));
const ContactDocumentsPage = lazy(() => import('@/pages/contacts/ContactDocumentsPage'));
const ContactInvoicesPage = lazy(() => import('@/pages/contacts/ContactInvoicesPage'));
const ContactCalendarPage = lazy(() => import('@/pages/contacts/ContactCalendarPage'));
const ContactJobsPage = lazy(() => import('@/pages/contacts/ContactJobsPage'));
const ContactNotificationSettingsPage = lazy(() => import('@/pages/contacts/ContactNotificationSettingsPage'));
const ContactReviewProcessesPage = lazy(() => import('@/pages/contacts/ContactReviewProcessesPage'));
const ContactReviewRequestsPage = lazy(() => import('@/pages/contacts/ContactReviewRequestsPage'));
const CompanyDetailPage = lazy(() => import('@/pages/contacts/CompanyDetailPage'));

export const contactRoutes: RouteObject[] = [
    {
        path: 'contacts',
        element: <ContactsPersonsPage />,
    },
    {
        path: 'contacts/:contactId',
        element: <ContactDetailLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="details" replace />,
            },
            {
                path: 'details',
                element: <ContactDetailsLayout />,
                children: [
                    { index: true, element: <Navigate to="information" replace /> },
                    { path: 'information', element: <ContactDetailsInformationTab /> },
                    { path: 'notes', element: <ContactDetailsNotesTab /> },
                    { path: 'settings', element: <ContactDetailsSettingsTab /> },
                ],
            },
            {
                path: 'bank-accounts',
                element: <ContactBankAccountsPage />,
            },
            {
                path: 'estates',
                element: <ContactEstatesPage />,
            },
            {
                path: 'documents',
                element: <ContactDocumentsPage />,
            },
            {
                path: 'invoices',
                element: <ContactInvoicesPage />,
            },
            {
                path: 'calendar',
                element: <ContactCalendarPage />,
            },
            {
                path: 'jobs',
                element: <ContactJobsPage />,
            },
            {
                path: 'review-requests',
                element: <ContactReviewRequestsPage />,
            },
            {
                path: 'review-processes',
                element: <ContactReviewProcessesPage />,
            },
            {
                path: 'notification-settings',
                element: <ContactNotificationSettingsPage />,
            },
        ],
    },
    {
        path: 'companies',
        element: <ContactsCompaniesPage />,
    },
    {
        path: 'companies/:id',
        element: <CompanyDetailPage />,
    },
];
